import { render, staticRenderFns } from "./AddLocation.vue?vue&type=template&id=631d4b58&"
import script from "./AddLocation.vue?vue&type=script&lang=js&"
export * from "./AddLocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports